var React = require('react');

function Section1TopMiddleInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"54","cy":"43","r":"43","fill":"#FEFCBE","key":0}),React.createElement("rect",{"width":"42","height":"42","y":"118","fill":"#E9D8FD","key":1}),React.createElement("circle",{"cx":"153","cy":"41","r":"16","fill":"#E7F5FF","key":2})]));
}

Section1TopMiddleInline.defaultProps = {"width":"169","height":"160","viewBox":"0 0 169 160"};

module.exports = Section1TopMiddleInline;

Section1TopMiddleInline.default = Section1TopMiddleInline;
